module.exports = __webpack_public_path__ + "img/lv_success_1.f0276131.png";